// @flow

import { type UserInputValidationError } from '@tectonics/prs/validation';

const KE_PHONE_REGEX = /^\+254 (?!254)\d{8,12}$/;

export function validateKenyanPhoneNumber(phoneNumberValue: string): ?UserInputValidationError {
  if (!phoneNumberValue || !phoneNumberValue.trim() || !parseInt(phoneNumberValue)) {
    return { id: 'empty' };
  } else if (!KE_PHONE_REGEX.test(phoneNumberValue) || phoneNumberValue.length < 13) {
    return { id: 'invalid-pattern' };
  }
}
